import "./index.css";
import "@babel/polyfill";

import {GoogleReCaptchaProvider,} from "react-google-recaptcha-v3";

import App from "./App";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom/client";
import appConfig from "./config";
import { persistStore } from "redux-persist";
import reportWebVitals from "./reportWebVitals";
import store from "./store";

Bugsnag.start({
  apiKey: "26e2b2b0d308726035de88692f1f72ff",
  plugins: [new BugsnagPluginReact()],
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
let persistor = persistStore(store);

const ErrorBoundary = Bugsnag.getPlugin("react")!.createErrorBoundary(React)!;

root.render(
  <GoogleReCaptchaProvider reCaptchaKey={appConfig.recaptchaSiteKey}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  </GoogleReCaptchaProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
